interface Props {
  color: string;
  size: number;
}

export function Sensor({ color, size }: Props) {
  return (
    <svg width={22 * size} viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_2700_757" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 21.8006C20.5617 19.9799 23 16.2747 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 16.2747 3.43832 19.9799 7 21.8006V25C7 25.5523 7.44772 26 8 26H16C16.5523 26 17 25.5523 17 25V21.8006Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 21.8006C20.5617 19.9799 23 16.2747 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 16.2747 3.43832 19.9799 7 21.8006V25C7 25.5523 7.44772 26 8 26H16C16.5523 26 17 25.5523 17 25V21.8006Z"
        fill="white"
      />
      <path
        d="M17 21.8006L16.4993 20.8211L15.9 21.1275V21.8006H17ZM7 21.8006H8.1V21.1275L7.50069 20.8211L7 21.8006ZM21.9 12C21.9 15.8456 19.7075 19.1811 16.4993 20.8211L17.5007 22.78C21.4158 20.7786 24.1 16.7037 24.1 12H21.9ZM12 2.1C17.4676 2.1 21.9 6.53238 21.9 12H24.1C24.1 5.31735 18.6826 -0.1 12 -0.1V2.1ZM2.1 12C2.1 6.53238 6.53238 2.1 12 2.1V-0.1C5.31735 -0.1 -0.1 5.31735 -0.1 12H2.1ZM7.50069 20.8211C4.29245 19.1811 2.1 15.8456 2.1 12H-0.1C-0.1 16.7037 2.58419 20.7786 6.49931 22.78L7.50069 20.8211ZM8.1 25V21.8006H5.9V25H8.1ZM8 24.9C8.05523 24.9 8.1 24.9448 8.1 25H5.9C5.9 26.1598 6.8402 27.1 8 27.1V24.9ZM16 24.9H8V27.1H16V24.9ZM15.9 25C15.9 24.9448 15.9448 24.9 16 24.9V27.1C17.1598 27.1 18.1 26.1598 18.1 25H15.9ZM15.9 21.8006V25H18.1V21.8006H15.9Z"
        fill={color}
        mask="url(#path-1-inside-1_2700_757)"
      />
      <mask
        id="path-3-outside-2_2700_757"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="27"
        fill="black"
      >
        <rect fill="white" width="24" height="27" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 21.8006C20.5617 19.9799 23 16.2747 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 16.2747 3.43832 19.9799 7 21.8006V25C7 25.5523 7.44772 26 8 26H16C16.5523 26 17 25.5523 17 25V21.8006Z"
        />
      </mask>
      <path
        d="M17 21.8006L16.8179 21.4444L16.6 21.5558V21.8006H17ZM7 21.8006H7.4V21.5558L7.18207 21.4444L7 21.8006ZM22.6 12C22.6 16.1187 20.2511 19.6894 16.8179 21.4444L17.1821 22.1567C20.8723 20.2703 23.4 16.4307 23.4 12H22.6ZM12 1.4C17.8542 1.4 22.6 6.14578 22.6 12H23.4C23.4 5.70395 18.296 0.6 12 0.6V1.4ZM1.4 12C1.4 6.14578 6.14578 1.4 12 1.4V0.6C5.70395 0.6 0.6 5.70395 0.6 12H1.4ZM7.18207 21.4444C3.74892 19.6894 1.4 16.1187 1.4 12H0.6C0.6 16.4307 3.12773 20.2703 6.81793 22.1567L7.18207 21.4444ZM7.4 25V21.8006H6.6V25H7.4ZM8 25.6C7.66863 25.6 7.4 25.3314 7.4 25H6.6C6.6 25.7732 7.2268 26.4 8 26.4V25.6ZM16 25.6H8V26.4H16V25.6ZM16.6 25C16.6 25.3314 16.3314 25.6 16 25.6V26.4C16.7732 26.4 17.4 25.7732 17.4 25H16.6ZM16.6 21.8006V25H17.4V21.8006H16.6Z"
        fill="#323B37"
        mask="url(#path-3-outside-2_2700_757)"
      />
      <circle cx="12" cy="12" r="8" fill={color} />
    </svg>
  );
}
